function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgActivityShipmentDeletion = function SvgActivityShipmentDeletion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z",
    style: {
      fill: "#fff",
      opacity: 0.22
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6 7.8 11.4 10l2.2 2.2a.99.99 0 0 1-1.4 1.4L10 11.4l-2.2 2.2a.99.99 0 0 1-1.4-1.4L8.6 10 6.4 7.8a.99.99 0 0 1 1.4-1.4L10 8.6l2.2-2.2a.99.99 0 0 1 1.4 1.4z",
    "data-name": "Path 11824",
    style: {
      fill: "#60122c"
    },
    transform: "translate(1.042 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 0a10 10 0 1 0 10 10A9.965 9.965 0 0 0 10 0zm0 18.2a8.066 8.066 0 0 1-8.1-8.1A8 8 0 0 1 10 2a8.066 8.066 0 0 1 8.1 8.1 8.2 8.2 0 0 1-8.1 8.1z",
    "data-name": "Path 11825",
    style: {
      fill: "#e03861"
    },
    transform: "translate(1.042 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8 16.8a1 1 0 0 1 0 2h-3.1v3.1a1 1 0 1 1-2 0v-3.1h-3.1a1 1 0 0 1 0-2h3.1v-3.1a1 1 0 0 1 2 0v3.1z",
    "data-name": "Path 11826",
    style: {
      fill: "#e03861"
    },
    transform: "rotate(45 23.044 5.181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6 12.2a.99.99 0 0 1-1.4 1.4L10 11.4l-2.2 2.2a.99.99 0 0 1-1.4-1.4L8.6 10 6.4 7.8a.99.99 0 0 1 1.4-1.4L10 8.6l2.2-2.2a.99.99 0 0 1 1.4 1.4L11.4 10z",
    "data-name": "Path 11827",
    style: {
      fill: "#e03861"
    },
    transform: "translate(1.042 1)"
  }));
};
export default SvgActivityShipmentDeletion;